<template><section><h2>其他</h2>
<h4>负值柱状图</h4>
<block-demo tip="" source="const data = [
  {
    product: &quot;茶叶&quot;,
    year: &quot;2016&quot;,
    sales: -81.2,
  },
  {
    product: &quot;茶叶&quot;,
    year: &quot;2017&quot;,
    sales: 121.2,
  },
  {
    product: &quot;茶叶&quot;,
    year: &quot;2018&quot;,
    sales: -41.2,
  },
  {
    product: &quot;牛奶&quot;,
    year: &quot;2016&quot;,
    sales: 85.2,
  },
  {
    product: &quot;牛奶&quot;,
    year: &quot;2017&quot;,
    sales: 79.6,
  },
  {
    product: &quot;牛奶&quot;,
    year: &quot;2018&quot;,
    sales: 81.2,
  },
  {
    product: &quot;咖啡&quot;,
    year: &quot;2016&quot;,
    sales: -65.2,
  },
  {
    product: &quot;咖啡&quot;,
    year: &quot;2017&quot;,
    sales: -59.6,
  },
  {
    product: &quot;咖啡&quot;,
    year: &quot;2018&quot;,
    sales: -61.2,
  },
  {
    product: &quot;椰汁&quot;,
    year: &quot;2016&quot;,
    sales: 35.2,
  },
  {
    product: &quot;椰汁&quot;,
    year: &quot;2017&quot;,
    sales: 79.6,
  },
  {
    product: &quot;椰汁&quot;,
    year: &quot;2018&quot;,
    sales: 21.2,
  },
]
const { Chart, Bar, Tooltip, Axis, Legend } = qcharts
const chart = new Chart({
  container: &quot;#app&quot;,
})
chart.source(data, {
  row: &quot;year&quot;,
  value: &quot;sales&quot;,
  text: &quot;product&quot;,
})
const bar = new Bar({
  transpose: false,
  barWidth: 20,
})
const tooltip = new Tooltip()
const legend = new Legend()
const axisBottom = new Axis().style(&quot;grid&quot;, false)
const axisLeft = new Axis({ orient: &quot;left&quot; }).style(&quot;grid&quot;, function(
  attrs,
  ind
) {
  if (ind === 3) {
    return { strokeColor: &quot;#999&quot;, lineDash: &quot;&quot; }
  }
})
chart.append([bar, tooltip, axisBottom, axisLeft, legend])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"茶叶"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2016"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">-81.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"茶叶"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2017"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">121.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"茶叶"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2018"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">-41.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"牛奶"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2016"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">85.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"牛奶"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2017"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">79.6</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"牛奶"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2018"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">81.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"咖啡"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2016"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">-65.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"咖啡"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2017"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">-59.6</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"咖啡"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2018"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">-61.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"椰汁"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2016"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">35.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"椰汁"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2017"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">79.6</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"椰汁"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2018"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">21.2</span>,
  },
]
<span class="hljs-keyword">const</span> { Chart, Bar, Tooltip, Axis, Legend } = qcharts
<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">"#app"</span>,
})
chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">"year"</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">"sales"</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">"product"</span>,
})
<span class="hljs-keyword">const</span> bar = <span class="hljs-keyword">new</span> Bar({
  <span class="hljs-attr">transpose</span>: <span class="hljs-literal">false</span>,
  <span class="hljs-attr">barWidth</span>: <span class="hljs-number">20</span>,
})
<span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip()
<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend()
<span class="hljs-keyword">const</span> axisBottom = <span class="hljs-keyword">new</span> Axis().style(<span class="hljs-string">"grid"</span>, <span class="hljs-literal">false</span>)
<span class="hljs-keyword">const</span> axisLeft = <span class="hljs-keyword">new</span> Axis({ <span class="hljs-attr">orient</span>: <span class="hljs-string">"left"</span> }).style(<span class="hljs-string">"grid"</span>, <span class="hljs-function"><span class="hljs-keyword">function</span>(<span class="hljs-params">
  attrs,
  ind
</span>) </span>{
  <span class="hljs-keyword">if</span> (ind === <span class="hljs-number">3</span>) {
    <span class="hljs-keyword">return</span> { <span class="hljs-attr">strokeColor</span>: <span class="hljs-string">"#999"</span>, <span class="hljs-attr">lineDash</span>: <span class="hljs-string">""</span> }
  }
})
chart.append([bar, tooltip, axisBottom, axisLeft, legend])
</code></pre>
</block-demo><h4>数据更新</h4>
<block-demo tip="" source="const data = [
  {
    product: &quot;茶叶&quot;,
    year: &quot;2016&quot;,
    sales: 81.2,
  },
  {
    product: &quot;茶叶&quot;,
    year: &quot;2017&quot;,
    sales: 121.2,
  },
  {
    product: &quot;茶叶&quot;,
    year: &quot;2018&quot;,
    sales: 41.2,
  },
  {
    product: &quot;牛奶&quot;,
    year: &quot;2016&quot;,
    sales: 85.2,
  },
  {
    product: &quot;牛奶&quot;,
    year: &quot;2017&quot;,
    sales: 79.6,
  },
  {
    product: &quot;牛奶&quot;,
    year: &quot;2018&quot;,
    sales: 81.2,
  },
  {
    product: &quot;咖啡&quot;,
    year: &quot;2016&quot;,
    sales: 65.2,
  },
  {
    product: &quot;咖啡&quot;,
    year: &quot;2017&quot;,
    sales: 59.6,
  },
  {
    product: &quot;咖啡&quot;,
    year: &quot;2018&quot;,
    sales: 61.2,
  },
  {
    product: &quot;椰汁&quot;,
    year: &quot;2016&quot;,
    sales: 35.2,
  },
  {
    product: &quot;椰汁&quot;,
    year: &quot;2017&quot;,
    sales: 79.6,
  },
  {
    product: &quot;椰汁&quot;,
    year: &quot;2018&quot;,
    sales: 21.2,
  },
]
const dataNew = [
  {
    product: &quot;茶叶&quot;,
    year: &quot;2016&quot;,
    sales: 81.2,
  },
  {
    product: &quot;茶叶&quot;,
    year: &quot;2017&quot;,
    sales: 121.2,
  },
  {
    product: &quot;茶叶&quot;,
    year: &quot;2018&quot;,
    sales: 41.2,
  },
  {
    product: &quot;茶叶&quot;,
    year: &quot;2019&quot;,
    sales: 61.2,
  },
  {
    product: &quot;牛奶&quot;,
    year: &quot;2016&quot;,
    sales: 85.2,
  },
  {
    product: &quot;牛奶&quot;,
    year: &quot;2017&quot;,
    sales: 79.6,
  },
  {
    product: &quot;牛奶&quot;,
    year: &quot;2018&quot;,
    sales: 81.2,
  },
  {
    product: &quot;牛奶&quot;,
    year: &quot;2019&quot;,
    sales: 111.2,
  },
  {
    product: &quot;咖啡&quot;,
    year: &quot;2016&quot;,
    sales: 65.2,
  },
  {
    product: &quot;咖啡&quot;,
    year: &quot;2017&quot;,
    sales: 59.6,
  },
  {
    product: &quot;咖啡&quot;,
    year: &quot;2018&quot;,
    sales: 61.2,
  },
  {
    product: &quot;咖啡&quot;,
    year: &quot;2019&quot;,
    sales: 161.2,
  },
]

let bool = true
const { Chart, Bar, Tooltip, Axis, Legend } = qcharts
const chart = new Chart({
  container: &quot;#app&quot;,
})
chart.source(data, {
  row: &quot;year&quot;,
  value: &quot;sales&quot;,
  text: &quot;product&quot;,
})
const bar = new Bar()
const tooltip = new Tooltip()
const legend = new Legend()
const axisBottom = new Axis()
const axisLeft = new Axis({ orient: &quot;left&quot; })
chart.append([bar, tooltip, axisBottom, axisLeft, legend])

setTimeout(changeData, 3000)
function changeData() {
  if (bool) {
    chart.source(dataNew, {
      row: &quot;year&quot;,
      value: &quot;sales&quot;,
      text: &quot;product&quot;,
    })
    bool = false
  } else {
    chart.source(data, {
      row: &quot;year&quot;,
      value: &quot;sales&quot;,
      text: &quot;product&quot;,
    })
    bool = true
  }
  setTimeout(changeData, 5000)
}
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"茶叶"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2016"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">81.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"茶叶"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2017"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">121.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"茶叶"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2018"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">41.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"牛奶"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2016"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">85.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"牛奶"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2017"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">79.6</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"牛奶"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2018"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">81.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"咖啡"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2016"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">65.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"咖啡"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2017"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">59.6</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"咖啡"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2018"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">61.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"椰汁"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2016"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">35.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"椰汁"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2017"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">79.6</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"椰汁"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2018"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">21.2</span>,
  },
]
<span class="hljs-keyword">const</span> dataNew = [
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"茶叶"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2016"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">81.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"茶叶"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2017"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">121.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"茶叶"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2018"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">41.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"茶叶"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2019"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">61.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"牛奶"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2016"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">85.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"牛奶"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2017"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">79.6</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"牛奶"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2018"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">81.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"牛奶"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2019"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">111.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"咖啡"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2016"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">65.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"咖啡"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2017"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">59.6</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"咖啡"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2018"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">61.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"咖啡"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"2019"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">161.2</span>,
  },
]

<span class="hljs-keyword">let</span> bool = <span class="hljs-literal">true</span>
<span class="hljs-keyword">const</span> { Chart, Bar, Tooltip, Axis, Legend } = qcharts
<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">"#app"</span>,
})
chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">"year"</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">"sales"</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">"product"</span>,
})
<span class="hljs-keyword">const</span> bar = <span class="hljs-keyword">new</span> Bar()
<span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip()
<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend()
<span class="hljs-keyword">const</span> axisBottom = <span class="hljs-keyword">new</span> Axis()
<span class="hljs-keyword">const</span> axisLeft = <span class="hljs-keyword">new</span> Axis({ <span class="hljs-attr">orient</span>: <span class="hljs-string">"left"</span> })
chart.append([bar, tooltip, axisBottom, axisLeft, legend])

setTimeout(changeData, <span class="hljs-number">3000</span>)
<span class="hljs-function"><span class="hljs-keyword">function</span> <span class="hljs-title">changeData</span>(<span class="hljs-params"></span>) </span>{
  <span class="hljs-keyword">if</span> (bool) {
    chart.source(dataNew, {
      <span class="hljs-attr">row</span>: <span class="hljs-string">"year"</span>,
      <span class="hljs-attr">value</span>: <span class="hljs-string">"sales"</span>,
      <span class="hljs-attr">text</span>: <span class="hljs-string">"product"</span>,
    })
    bool = <span class="hljs-literal">false</span>
  } <span class="hljs-keyword">else</span> {
    chart.source(data, {
      <span class="hljs-attr">row</span>: <span class="hljs-string">"year"</span>,
      <span class="hljs-attr">value</span>: <span class="hljs-string">"sales"</span>,
      <span class="hljs-attr">text</span>: <span class="hljs-string">"product"</span>,
    })
    bool = <span class="hljs-literal">true</span>
  }
  setTimeout(changeData, <span class="hljs-number">5000</span>)
}
</code></pre>
</block-demo><h4>开方数据柱状图</h4>
<block-demo tip="" source="const data = [
  { abc: 25, label: &quot;05-01&quot; },
  { abc: 36, label: &quot;05-02&quot; },
  { abc: 49, label: &quot;05-03&quot; },
  { abc: 64, label: &quot;05-04&quot; },
  { abc: 81, label: &quot;05-05&quot; },
  { abc: 100, label: &quot;05-06&quot; },
  { abc: 400, label: &quot;05-07&quot; },
  { abc: 900, label: &quot;05-08&quot; },
]
const { Chart, Bar, Tooltip, Axis, Legend } = qcharts
const chart = new Chart({
  container: &quot;#app&quot;,
})
chart.source(data, {
  value: &quot;abc&quot;,
  text: &quot;label&quot;,
  layoutScale: &quot;sqrt&quot;,
})
const bar = new Bar({})
const tooltip = new Tooltip()

const axisBottom = new Axis().style(&quot;grid&quot;, false)
const axisLeft = new Axis({ orient: &quot;left&quot; })
  .style(&quot;axis&quot;, false)
  .style(&quot;scale&quot;, false)
chart.append([bar, tooltip, axisBottom, axisLeft])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  { <span class="hljs-attr">abc</span>: <span class="hljs-number">25</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"05-01"</span> },
  { <span class="hljs-attr">abc</span>: <span class="hljs-number">36</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"05-02"</span> },
  { <span class="hljs-attr">abc</span>: <span class="hljs-number">49</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"05-03"</span> },
  { <span class="hljs-attr">abc</span>: <span class="hljs-number">64</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"05-04"</span> },
  { <span class="hljs-attr">abc</span>: <span class="hljs-number">81</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"05-05"</span> },
  { <span class="hljs-attr">abc</span>: <span class="hljs-number">100</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"05-06"</span> },
  { <span class="hljs-attr">abc</span>: <span class="hljs-number">400</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"05-07"</span> },
  { <span class="hljs-attr">abc</span>: <span class="hljs-number">900</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"05-08"</span> },
]
<span class="hljs-keyword">const</span> { Chart, Bar, Tooltip, Axis, Legend } = qcharts
<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">"#app"</span>,
})
chart.source(data, {
  <span class="hljs-attr">value</span>: <span class="hljs-string">"abc"</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">"label"</span>,
  <span class="hljs-attr">layoutScale</span>: <span class="hljs-string">"sqrt"</span>,
})
<span class="hljs-keyword">const</span> bar = <span class="hljs-keyword">new</span> Bar({})
<span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip()

<span class="hljs-keyword">const</span> axisBottom = <span class="hljs-keyword">new</span> Axis().style(<span class="hljs-string">"grid"</span>, <span class="hljs-literal">false</span>)
<span class="hljs-keyword">const</span> axisLeft = <span class="hljs-keyword">new</span> Axis({ <span class="hljs-attr">orient</span>: <span class="hljs-string">"left"</span> })
  .style(<span class="hljs-string">"axis"</span>, <span class="hljs-literal">false</span>)
  .style(<span class="hljs-string">"scale"</span>, <span class="hljs-literal">false</span>)
chart.append([bar, tooltip, axisBottom, axisLeft])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>